import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Button, Modal } from 'react-bootstrap'
import { connectModal } from 'redux-modal'

class DeleteModal extends Component {
  constructor(props) {
    super(props)

    this.handleConfirm = this.handleConfirm.bind(this)
  }

  handleConfirm() {
    this.props.id ? this.props.handleDelete(this.props.id) : this.props.handleDelete()
    this.props.handleHide()
  }

  render() {
    const { show, handleHide } = this.props

    return (
      <Modal size='md' show={show} onHide={handleHide}>
        <Modal.Header className='bg-light' closeButton>
          <Modal.Title>Confirm Deletion</Modal.Title>
        </Modal.Header>

        <Modal.Body>{`Are you sure you want to delete ${this.props.message}?`}</Modal.Body>

        <Modal.Footer>
          <Button size='sm' variant='secondary' onClick={handleHide}>
            Cancel
          </Button>
          <Button size='sm' variant='danger' onClick={this.handleConfirm}>
            Yup!
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }
}

DeleteModal.propTypes = {
  id: PropTypes.string,
  handleDelete: PropTypes.func,
  handleHide: PropTypes.func.isRequired,
  message: PropTypes.string,
  show: PropTypes.bool.isRequired
}

export default connectModal({ name: 'deleteModal' })(DeleteModal)
